import * as React from 'react'
import {Helmet} from 'react-helmet'

export default React.memo(
  ({
    author,
    canonicalUrl,
    datePublished,
    dateModified,
    defaultTitle,
    description,
    image,
    isBlogPost,
    organization,
    title,
    url,
  }) => {
    //console.log("ORG",organization);
    const baseSchema = [

      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "New York",
          "addressRegion": "NY",
          "postalCode": "10022",
          "streetAddress": "30 E 60th St #1103"
        },
        "telephone": "+12012450649",
        "email": "mailto:info@longmakeup.com",
        "url": "https://www.longmakeup.com",
        "name": "LongMakeup ★ Permanent Makeup NYC",
        "priceRange": "$$",
        "image": `${organization.logo}`,
        "description": "Discover permanent beauty secret to looking gorgeous anywhere you go. Start with eyebrows microblading the most popular treatment - they make a person’s face! Find out more about new brows micropigmentation techniques powder brows, ombré brows, and micro shading brows.",
        "currenciesAccepted": "USD",
        "paymentAccepted":"Cash, Credit Card",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-201-245-0649",
          "contactType": "Customer Service"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "40.763877",
          "longitude": "-73.970232"
        }
      }

    ]

    const schema = isBlogPost
      ? [
          ...baseSchema,
          {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@id': url,
                  name: title,
                  image,
                },
              },
            ],
          },
          {
            '@context': 'http://schema.org',
            '@type': 'BlogPosting',
            url,
            name: title,
            alternateName: defaultTitle,
            headline: title,
            image: {
              '@type': 'ImageObject',
              url: image,
            },
            description,
            author: {
              '@type': 'Person',
              name: author,
            },
            publisher: {
              '@type': 'Organization',
               url: organization.url,
               logo: organization.logo,
              name: organization.name,
            },
            mainEntityOfPage: {
              '@type': 'WebSite',
              '@id': canonicalUrl,
            },
            datePublished,
             dateModified,
          },
        ]
      : baseSchema

    return (
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">{JSON.stringify(schema, null, 2)}</script>
      </Helmet>
    )
  },
)
